<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <div>
            <b-calendar v-model="selectedDate" @input="onDateSelect" :highlighted="highlightedDates" class="m-1"
                locale="en">
            </b-calendar>
            <div v-if="startDate && endDate" class="m-1">
                <span class="badge text-bg-success">Fecha inicio: {{ startDate }}</span>
                <span class="badge text-bg-success">Fecha fin: {{ endDate }}</span>
            </div>

            <div class="d-flex justify-content-center">
                <button v-on:click="filterDate" type="button" class="btn btn-outline-primary m-2">Filtrar</button>
            </div>
        </div>
    </div>
</template>
<script>
//signal R
import {
    allDocumentsSignalRInvoke,
    countDenunciationsSignalRInvoke,
    countDocumentsSignalRInvoke,
    countSendDenunciationSignalRInvoke,
    countSendDocumentsSignalRInvoke,
    countMeetsSignalRInvoke,
    countStatementsSignalRInvoke,
    countSendStatementsSignalRInvoke,
    countKarinDenunciationsSignalRInvoke
} from '@/plugins/storeSignalRInvoque/index.js';

//alert, enum
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'

//mixin
import { dashboardGraph } from '@/plugins/mixin/index.js'

export default {
    name: 'DashboardFilterCalendar',

    mixins:[ dashboardGraph ],

    data() {
        return {
            selectedDate: null,
            startDate: null,
            endDate: null,
            highlightedDates: []
        };
    },

    components: {
        AlertDismiss
    },

    methods: {
        async filterDate() {
            //signal R invoke - back to front
            await allDocumentsSignalRInvoke(this.startDate, this.endDate);
            await countDenunciationsSignalRInvoke(this.startDate, this.endDate);
            await countDocumentsSignalRInvoke(this.startDate, this.endDate);
            await countSendDenunciationSignalRInvoke(this.startDate, this.endDate);
            await countSendDocumentsSignalRInvoke(this.startDate, this.endDate);
            await countMeetsSignalRInvoke(this.startDate, this.endDate);
            await countStatementsSignalRInvoke(this.startDate, this.endDate);
            await countSendStatementsSignalRInvoke(this.startDate, this.endDate);
            await countKarinDenunciationsSignalRInvoke(this.startDate, this.endDate);

            //para no sequir actualizando la grafica y mostrar filtro en pantalla
            const data = {
                mixinItUpdates: false,
                mixinStartDate: this.startDate,
                mixinEndDate: this.endDate,
                mixinShowFilter: true
            };

            this.modifyGraph(data)

            //evento al padre para cerrar modal
            this.$emit('closeModalParentEvent');

            //limpiar
            this.clear();
        },

        onDateSelect(date) {
            if (!this.startDate) {
                this.startDate = date;
                this.endDate = null; // Reset end date if a new start date is selected
            } else if (!this.endDate) {
                if (date >= this.startDate) {
                    this.endDate = date;
                } else {
                    // If selected date is before start date, set it as new start date
                    this.startDate = date;
                }
            } else {
                // If both start and end dates are selected, reset selection
                this.startDate = date;
                this.endDate = null;
            }

            // Update highlighted dates to visually show the range
            this.updateHighlightedDates();
        },

        updateHighlightedDates() {
            if (this.startDate && this.endDate) {
                this.highlightedDates = this.getDateRange(this.startDate, this.endDate);
            } else {
                this.highlightedDates = [];
            }
        },

        getDateRange(start, end) {
            const dates = [];
            let current = new Date(start);
            while (current <= end) {
                dates.push(current.toISOString().split('T')[0]); // Format date as YYYY-MM-DD
                current.setDate(current.getDate() + 1);
            }
            return dates;
        },

        clear() {
            this.startDate = null;
            this.endDate = null;
            this.highlightedDates = [];
        }
    }

}
</script>
<style></style>
